<template>
    <div class="main-content">
        <!-- Start Hero Section -->
        <section class="hero-section gradient-overlay" id="home">
            <div class="swiper-container main-slider no-scroll-bar">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="slide-inner bg-image" data-image-src="assets/images/slider-img/Pic3.jpeg">
                            <div class="slide-content text-white">
                                <h2 class="mb-0 text-center">
                                    Build Better, Build Stronger, MoveAmerica
                                </h2>
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="slide-inner bg-image w-100 ria-image no-scroll-bar" data-image-src="assets/images/slider-img/slide-ria.jpg">
                            <div class="slide-content text-white w-100">
                                <div class="slide-ria">
                                    <div class="">
                                        <div class="ria-logo">
                                            <img src="../assets/images/ria/RIA.svg" alt="" class="logo" />
                                            <img src="../assets/images/ria/qr-code.png" class="qr-code" />
                                        </div>
                                        <h2 class="ria-header">Rapid Innovation Acceleration</h2>
                                        <div class="ria-text desktop">
                                            <div>
                                                Empowering Innovation
                                            </div>
                                            <div>through Strategic</div>
                                            <div>Partnerships</div>
                                        </div>
                                        <div class="ria-text tablet">
                                            <div>
                                                Empowering Innovation through Strategic Partnerships
                                            </div>
                                        </div>
                                        <router-link to="/ria">
                                            <div class="meet-ria-container">
                                                <button class="btn-golden">
                                                    Meet RIA
                                                </button>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="ria-desc">
                                        <p>
                                            MoveAmerica is powering the rapid innovation in collaboration with the U.S. Department of Defense (DoD)
                                            Office of Small Business Programs through the Mentor-Protégé Program (MPP). The goal of this initiative is
                                            to strengthen our national defense supply chain by fostering innovation through partnerships with industry
                                            and academia.
                                        </p>
                                        <p>
                                            Our main mission in this effort is to establish and execute MPP agreements across the Armed Services and
                                            Defense Agencies. The MPP connects small businesses that want to join or participate in the Defense
                                            Industrial Base (DIB) with larger companies that can provide the guidance needed to navigate the
                                            complicated government procurement process.
                                        </p>
                                        <div class="ria-qr-container">
                                            <p>
                                                These strategic partnerships will allow smaller companies to develop and advance critical and emerging
                                                technology that will allow the U.S. military to reassert and maintain its technical dominance.
                                            </p>
                                            <img src="../assets/images/ria/qr-code.png" width="184" height="180" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
                <div class="swiper-button-next swiper-button-white"></div>
                <div class="swiper-button-prev swiper-button-white"></div>
            </div>
        </section>
        <!--End Hero Section -->
        <!-- Start About Area -->
        <section class="about-area section" id="aboutus">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12">
                        <div class="about-title section-title">
                            <span><strong> IDEAS. TECHNOLOGY. SOLUTIONS.</strong></span>
                            <h2><strong> MoveAmerica </strong></h2>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="about-text pl-4">
                            <p>
                                <strong>
                                    MoveAmerica is a non-profit organization focused on solving the critical challenges facing America's industrial
                                    base and supply chain.
                                </strong>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- End About Area -->
        <!-- Start Services Area -->
        <section class="section parallax-bg" id="services">
            <div class="container">
                <div class="section-title text-center z-index9">
                    <h2 class="text-white">
                        MoveAmerica Partnerships Drive Defense Innovation
                    </h2>
                    <p class="text-white">
                        MoveAmerica brings together the key participants needed to develop and advance critical and emerging technology that will
                        maintain U.S. technical dominance. Our ‘whole of nation’ approach allows us to focus assets on the critical areas that ensure
                        the superiority of our nation’s defense.
                    </p>
                </div>
                <div class="service-boxes-area">
                    <div class="row">
                        <div class="col-lg-4 col-md-6 col-sm-6">
                            <div
                                class="single-service-box mt-30 p-4 bg-white wow fadeIn"
                                data-wow-delay="0.2s"
                                data-wow-duration="1s"
                                style="height:360px"
                            >
                                <div class="icon">
                                    <!-- <i class="mdi mdi-office"></i> -->
                                    <img src="../assets/images/icons/FFRDCS.svg" alt="" />
                                </div>
                                <h3>Government</h3>
                                <p>
                                    MoveAmerica works with the U.S. Department of Defense and other relevant agencies and partners to solve the most
                                    critical challenges to America's industrial base and supply chain.
                                </p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6">
                            <div
                                class="single-service-box mt-30 p-4 bg-white wow fadeIn"
                                data-wow-delay="0.4s"
                                data-wow-duration="1s"
                                style="height:360px"
                            >
                                <div class="icon">
                                    <!-- <i class="mdi mdi-network"></i> -->
                                    <img src="../assets/images/icons/DODlabs.svg" alt="" />
                                </div>
                                <h3>Academia</h3>
                                <p>
                                    MoveAmerica employs and deploys leading academic experts in science and technology to provide sound guidance,
                                    proficient expertise, and practical solutions to our nation’s leaders.
                                </p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6">
                            <div
                                class="single-service-box mt-30 p-4 bg-white wow fadeIn"
                                data-wow-delay="0.6s"
                                data-wow-duration="1s"
                                style="height:360px"
                            >
                                <div class="icon">
                                    <!-- <i class="mdi mdi-robot"></i> -->
                                    <img src="../assets/images/icons/nontraditional.svg" alt="" />
                                </div>
                                <h3>Industry</h3>
                                <p>
                                    MoveAmerica is the trusted, impartial companion that is there every step of the way to help identify and build
                                    what America’s industrial base needs to stay competitive.
                                </p>
                            </div>
                        </div>
                        <!-- <div class="col-lg-4 col-md-6 col-sm-6">
                            <div class="single-service-box mt-30 p-4 bg-white wow fadeIn" data-wow-delay="0.8s" data-wow-duration="1s" style="height:400px">
                                <div class="icon">
									<img src="../assets/images/icons/traditional.svg" alt="">
                                </div>
                                <h3>Traditional Defense Industry and Academia​</h3>
                                <p>
									Current US defense contractors and academic partners have been the envy of the world in terms of innovation and providing the U.S. with war-winning combat capacity. Their experience and production capacity will be instrumental to the nation's ability to maintain technological superiority.
								</p>
                            </div>
                        </div>
						<div class="col-lg-4 col-md-6 col-sm-6" >
                            <div class="single-service-box mt-30 p-4 bg-white wow fadeIn" data-wow-delay="0.8s" data-wow-duration="1s" style="height:400px">
                                <div class="icon">
									<img src="../assets/images/icons/development.svg" alt="">
                                </div>
                                <h3>DoD System Development Organization​</h3>
                                <p>
									The DoD acquisition and R&D workforce is the premier group of engineers, scientist, and managers that know how to design, produce, integrate, and support combat systems that maintain the country’s ability to defend itself.
								</p>
                            </div>
                        </div>
						<div class="col-lg-4 col-md-6 col-sm-6">
                            <div class="single-service-box mt-30 p-4 bg-white wow fadeIn" data-wow-delay="0.8s" data-wow-duration="1s" style="height:400px">
                                <div class="icon">
									<img src="../assets/images/icons/nationallabs.svg" alt="">
                                </div>
                                <h3>National Laboratories​</h3>
                                <p>
									National Laboratories lead the discovery, development and delivery of critical strategic technologies for the nation. They identify and cultivate the technologies that only a few in the world understand.
								</p>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </section>
        <section class="section">
            <div class="container">
                <!-- <div class="section-title text-center z-index9">
          <h2>Key Tenets</h2>
          <br />
          <br />
        </div> -->
                <div class="row">
                    <div class="col-12">
                        <div class="img-container">
                            <img src="../assets/images/images/Tenets.png" alt="" class="img-fluid" />
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />
            <br />
            <div class="container">
                <div class="row">
                    <div class="col-lg-8">
                        <!-- <div class= "d-flex flex-sm-row flex-column">
								<button class="btn2">Identify/maintain technology awareness to build institute capability and capacity​ </button>
								<button class="btn4">Locate/recruit innovators, reduce entry barriers, and provide mentor services </button>
								<button class="btn3">Accelerate development, demonstration, integration and delivery  </button>
							</div> -->
                        <div class="section-title">
                            <h3 class="position-relative pb-3 mb-4 text-center">
                                <strong>Partner with us today and let us continue to move America forward. </strong>
                            </h3>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="justify-center">
                            <br />
                            <center>
                                <router-link to="/contact">
                                    <button type="button" class="btn btn-outline-success">
                                        Get in Touch with US!
                                    </button>
                                </router-link>
                            </center>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
//WOW JS
import { WOW } from "wowjs";
import news from "./news";

// import Swiper styles
import "../assets/css/swiper.min.css";
// core version + navigation, pagination modules:
import Swiper, { Autoplay, Navigation, Pagination } from "swiper";
// configure Swiper to use modules
Swiper.use([Autoplay, Navigation, Pagination]);
//ISOTOP JS
import "../assets/js/jquery.isotope.min.js";
import * as ScrollMagic from "scrollmagic"; // Or use scrollmagic-with-ssr to avoid server rendering problems
import { TweenMax, TimelineMax } from "gsap"; // Also works with TweenLite and TimelineLite
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

//MAGNIFIC POPUP JS
import "magnific-popup/dist/jquery.magnific-popup.min.js";
import "magnific-popup/dist/magnific-popup.css";
export default {
    name: "index",
    components: {
        news,
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.initMainSlider();
            this.initBackgroundImage();
            this.initWowAnimation();
            this.initAccordian();
            this.windowScroll();
            this.initTestimonialSlider();
            this.initFooterHeight();
            this.initIsotop();
            this.initMagnificPopup();
            this.initScaleImage();
        },
        /*----MAIN ANIMATION-----*/
        initMainSlider() {
            var swiperOptions = {
                loop: true,
                speed: 1000,
                grabCursor: true,
                watchSlidesProgress: true,
                mousewheelControl: true,
                keyboardControl: true,
                autoplay: {
                    delay: 6000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            };
            var swiper = new Swiper(".main-slider", swiperOptions);
        },
        /*----BACKGROUND IMAGE-----*/
        initBackgroundImage() {
            $(".bg-image").css("background", function() {
                var bg = "url(" + $(this).data("image-src") + ") no-repeat center center";
                return bg;
            });
        },
        initFooterHeight() {
            var footerHeight = $("footer").outerHeight();
            $(".main-content").css("margin-bottom", footerHeight);
        },
        /*----WOW ANIMATION-----*/
        initWowAnimation() {
            var length = $(".wow").length;
            if (length >= 1) {
                const wow = new WOW({
                    boxClass: "wow",
                    animateClass: "animated",
                    offset: 0,
                });
                wow.init();
            }
        },
        /*----ONSCROLL JS-----*/
        windowScroll() {
            var self = this;
            $(window).on("scroll", function() {
                //self.initCounter();
            });
        },
        /*----ACCORDIAN-----*/
        initAccordian() {
            $(".question-card").on("click", function() {
                if ($(this).hasClass("active")) {
                    $(".question-card").removeClass("active");
                    $(this).removeClass("active");
                } else {
                    $(".question-card").removeClass("active");
                    $(this).addClass("active");
                }
            });
        },
        /*----TESTIMONIAL SLIDER-----*/
        initTestimonialSlider() {
            if ($(".swiper-container").length > 0) {
                var swiper = new Swiper(".client-container", {
                    slidesPerView: 1,
                    draggable: true,
                    spaceBetween: 10,
                    // init: false,
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: 1,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 40,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 50,
                        },
                    },
                });
            }
        },
        /*----ISOTOP JS-----*/
        initIsotop() {
            var $container = $(".portfolio-items");
            $container.imagesLoaded(function() {
                $container.isotope({
                    filter: "*",
                    animationOptions: {
                        duration: 750,
                        easing: "linear",
                        queue: false,
                    },
                });
            });

            $(".portfolio-filter li a").click(function() {
                $(".portfolio-filter .current").removeClass("current");
                $(this).addClass("current");
                var selector = $(this).attr("data-filter");
                $container.isotope({
                    filter: selector,
                    animationOptions: {
                        duration: 750,
                        easing: "linear",
                        queue: false,
                    },
                });
                return false;
            });
        },
        /*----MAGNIFIC POPUP JS-----*/
        initMagnificPopup() {
            if (".portfolio-items".length > 0) {
                $(".portfolio-items").each(function() {
                    $(this).magnificPopup({
                        delegate: ".js-zoom-gallery",
                        type: "image",
                        gallery: {
                            enabled: true,
                        },
                    });
                });
            }
        },
        initScaleImage() {
            var controller = new ScrollMagic.Controller();
            var slides = $(".scale-image");
            for (var i = 0; i < slides.length; i++) {
                var image = $("img", slides[i]);
                var tween = TweenMax.to(image, 1, { scale: 1.2 });
                var scene = new ScrollMagic.Scene({
                    triggerElement: slides[i],
                    duration: "200%",
                    triggerHook: "onEnter",
                })
                    .setTween(tween)
                    .addTo(controller);
            }
        },
    },
};
</script>
<style scoped>
.swiper-button-next {
    position: absolute;
    top: 70%;
    right: 20px;
}

.swiper-button-prev {
    position: absolute;
    top: 70%;
    right: 0;
}

.box {
    box-sizing: border-box;
    border: 3px solid transparent;
    background-clip: padding-box;
}

.img-container {
    text-align: center;
    display: block;
}

.swiper-container {
    overflow-y: auto;
}
.ria-image {
    overflow-y: auto;
}
.main-slider .swiper-slide .slide-inner:after {
    background: none;
}
.swiper-button-white {
    border: none;
    top: 50%;
}
.swiper-button-prev {
    left: 15px;
}
.swiper-button-next {
    right: 5px;
}
.swiper-button-white::after {
    display: none;
}
@media (max-width: 768px) {
    .swiper-button-white {
        display: none;
    }
}

.swiper-button-prev {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%234c71ae'%2F%3E%3C%2Fsvg%3E") !important;
}

.swiper-button-next {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%234c71ae'%2F%3E%3C%2Fsvg%3E") !important;
}
</style>
